const Floodlight = {
  enable() {},
  wait() {
    return true;
  },
  init() {},
  landing() {},
  paso1() {},
  paso2() {},
  paso3() {},
  paso4() {},
  gracias() {
    let ifrm = document.createElement("iframe");
    ifrm.height = 0;
    ifrm.width = 0;
    ifrm.style = "display:none";
    ifrm.src =
      "https://8006394.fls.doubleclick.net/activityi;src=8006394;type=thank0;cat=landi0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=1?";

    document.body.appendChild(ifrm);
  },
  mensaje() {}
};

export default Floodlight;
